import { Amplify } from "aws-amplify"
import {cognito_amplify_config} from "./config";
Amplify.configure(cognito_amplify_config)